import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./OurTools.css";
import SEOHead from './SEOHead';
import Footer from './Footer';
import TextType from './TextType';
// Nidhi Product Images
import nidhiLaptopImg from '../product-section-img/nidhi-laptop.png';
import nidhiMobileImg from '../product-section-img/nidhi-mobile.png';
// FacultyOS Product Images
import facultyOSImg from '../product-section-img/facultyOS.png';
// Product Logos
import urimaiLogo from '../img/urimai-logo.png';
import nidhiLogo from '../img/Nidhi-logo.png';
import facultyOSLogo from '../img/FacultyOS-logo.png';
// Emerging Innovations Logos
import courseCuratorLogo from '../product-section-img/course-curator-logo.png';
import thisaiLogo from '../product-section-img/thisai-logo.png';

// TiltedCard component
import TiltedCard from './TiltedCard';

// URIMAI screenshots for slideshow
const urimaiScreenshots = [
  require("../Urimai Img/2 3.png"),
  require("../Urimai Img/3 5.png"),
  require("../Urimai Img/4 5.png"),
  require("../Urimai Img/5 2.png"),
  require("../Urimai Img/6 2.png"),
  require("../Urimai Img/8 2.png"),
  require("../Urimai Img/9 2.png"),
];

// Product data - உரிமை
const urimaiData = {
  title: "உரிமை",
  subtitle: "Civic Transparency Platform for Informed Voting",
  logo: require("../Urimai Img/main.png"),
  badge: "NEW",
  features: [
    "Verified Candidate Profiles",
    "Smart Candidate Search",
    "Bilingual Accessibility (English & Tamil)",
    "Financial & Criminal Record Analysis",
    "Real-Time Data Integration",
    "Transparent Public Information"
  ],
  screenshots: urimaiScreenshots
};



const FeaturedProductsHero = ({ onExploreProducts, onWorkWithUs }) => {
  const [counts, setCounts] = useState({
    ownProducts: 0,
    liveScaling: 0,
    inDevelopment: 0,
    endUsers: 0
  });



  // Device detection for Urimai
  const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return 'android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }
    return 'web';
  };

  // Click handlers for each product
  const handleUrimaiClick = () => {
    console.log('Urimai clicked');
    const device = detectDevice();
    let url;
    if (device === 'android') {
      url = 'https://play.google.com/store/apps/details?id=com.urimaiapp';
    } else if (device === 'ios') {
      url = 'https://apps.apple.com/in/app/urimai/id6475168659';
    } else {
      // Default to Android Play Store for web users
      url = 'https://play.google.com/store/apps/details?id=com.urimaiapp';
    }
    console.log('Opening URL:', url);
    window.open(url, '_blank');
  };

  const handleNidhiClick = () => {
    console.log('Nidhi clicked');
    console.log('Opening URL: https://nidhi-ak.in/');
    window.open('https://nidhi-ak.in/', '_blank');
  };

  const handleFacultyOSClick = () => {
    console.log('FacultyOS clicked');
    console.log('Opening URL: https://www.facultyos.net/');
    window.open('https://www.facultyos.net/', '_blank');
  };

  // Counter animation effect
  useEffect(() => {
    const animateCounter = (target, key, suffix = '') => {
      let current = 0;
      const increment = target / 50; // 50 steps for smooth animation
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          const finalValue = target < 10 ? `0${target}` : target.toString();
          setCounts(prev => ({ ...prev, [key]: finalValue + suffix }));
          clearInterval(timer);
        } else {
          const currentValue = Math.floor(current);
          const displayValue = currentValue < 10 ? `0${currentValue}` : currentValue.toString();
          setCounts(prev => ({ ...prev, [key]: displayValue + suffix }));
        }
      }, 30);
    };

    // Start animations with slight delays
    setTimeout(() => animateCounter(10, 'ownProducts'), 500);
    setTimeout(() => animateCounter(5, 'liveScaling'), 700);
    setTimeout(() => animateCounter(5, 'inDevelopment'), 900);
    setTimeout(() => animateCounter(50, 'endUsers', 'K+'), 1100);
  }, []);

  return (
    <div className="products-hero-section" data-aos="fade-up">
      <div className="products-hero-content">
        <div className="products-hero-left">
          <div className="product-badge">
            Product-First by Nature • Coimbatore, India
          </div>

          <h1 className="products-hero-title">
            <span className="title-first-line">We Don't Just Build Products.</span><br />
            <span className="title-second-line highlight-text">WE BUILD</span><br />
            <TextType 
              text={["What Comes Next.", "Better Ways Forward.", "Products With Purpose.", "Ideas Worth Shipping."]}
              typingSpeed={75}
              pauseDuration={2000}
              showCursor={true}
              cursorCharacter="_"
              deletingSpeed={50}
              cursorBlinkDuration={0.5}
              className="typing-text title-third-line"
            />
          </h1>

          <p className="products-hero-description">
Products born from real problems. AK Consultants is a product studio at its core - our own products keep us sharp, opinionated, and genuinely product-first. Every client project benefits from the lessons we learn building our own.          </p>

          <div className="hero-buttons">
            <button className="btn-work-with-us" onClick={onWorkWithUs}>
              Work With Us →
            </button>
            <button className="btn-explore-products" onClick={onExploreProducts}>
              Explore
            </button>
          </div>

          <div className="product-stats">
            <div className="stat-item">
              <span className="stat-number">{counts.ownProducts}</span>
              <span className="stat-label">Own Products</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{counts.liveScaling}</span>
              <span className="stat-label">Live & Scaling</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{counts.inDevelopment}</span>
              <span className="stat-label">In Development</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{counts.endUsers}</span>
              <span className="stat-label">End Users</span>
            </div>
          </div>
        </div>

        <div className="products-hero-right">
          <div className="product-portfolio-container">
            <div className="product-portfolio-preview">
              <div className="portfolio-header">
                <span className="portfolio-title">Explore Product Portfolio</span>
                <span className="portfolio-count">3 Live <span className="glow-dot">●</span></span>
              </div>
              
              <div className="product-cards-preview">
                <div 
                  className="product-card-mini urimai-card" 
                  onClick={(e) => {
                    e.stopPropagation();
                    handleUrimaiClick();
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label="Visit Urimai - Tamil Nadu's civic transparency platform"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleUrimaiClick();
                    }
                  }}
                >
                  <div className="card-logo">
                    <img src={urimaiLogo} alt="Urimai Logo" />
                  </div>
                  <div className="card-content">
                    <span className="card-name">Urimai</span>
                    <span className="card-category">Tamil Nadu's first civic transparency platform.<br />
                    Empowers citizens with verified candidate data.</span>
                  </div>
                  <span className="card-status live">Live</span>
                </div>

                <div 
                  className="product-card-mini nidhi-card" 
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNidhiClick();
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label="Visit Nidhi - AI-powered invoice processing platform"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleNidhiClick();
                    }
                  }}
                >
                  <div className="card-logo">
                    <img src={nidhiLogo} alt="Nidhi Logo" />
                  </div>
                  <div className="card-content">
                    <span className="card-name">Nidhi</span>
                    <span className="card-category">AI-powered invoice processing & GST compliance.<br />
                    Automates financial workflows for enterprises.</span>
                  </div>
                  <span className="card-status live">Live</span>
                </div>

                <div 
                  className="product-card-mini facultyos-card" 
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFacultyOSClick();
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label="Visit FacultyOS - Complete faculty workload management system"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleFacultyOSClick();
                    }
                  }}
                >
                  <div className="card-logo">
                    <img src={facultyOSLogo} alt="FacultyOS Logo" />
                  </div>
                  <div className="card-content">
                    <span className="card-name">FacultyOS</span>
                    <span className="card-category">Complete faculty workload management system.<br />
                    Streamlines academic operations & scheduling.</span>
                  </div>
                  <span className="card-status live">Live</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SolutionsInnovationStrip = () => {
  const [fgVisible, setFgVisible] = useState(false);
  const stripRef = useRef(null);
  const bgRef = useRef(null);
  const fgRef = useRef(null);

  // Scroll-driven: bg text rises up (parallax) + fades in; reverses on scroll up
  useEffect(() => {
    const bg = bgRef.current;
    // On mobile the strip is shorter and text smaller - apply bolder weight once
    if (bg && window.innerWidth <= 768) {
      bg.style.fontWeight = '1250';
      bg.style.webkitTextStroke = '0.5px rgba(255,255,255,0.15)';
    }

    const update = () => {
      const strip = stripRef.current;
      if (!strip || !bg) return;
      const rect = strip.getBoundingClientRect();
      const winH = window.innerHeight;
      // progress: 0 when strip bottom just enters viewport, 1 when strip top hits viewport top
      const progress = Math.min(Math.max((winH - rect.top) / (rect.height + winH * 0.3), 0), 1);
      // On mobile: travel only 40px so white top stays visible; desktop: 120px
      const travel = window.innerWidth <= 768 ? 40 : 120;
      const ty = travel - progress * travel;
      const op = 0.08 + progress * 0.77;
      bg.style.opacity = op;
      bg.style.transform = `translateX(-50%) translateY(${ty}px)`;
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  // Fg fade-up - reversible (shows/hides based on intersection)
  useEffect(() => {
    const el = fgRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setFgVisible(entry.isIntersecting),
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="solutions-innovation-strip" ref={stripRef}>
      {/* Giant bg text */}
      <div className="solutions-bg-text" ref={bgRef} aria-hidden="true">
        Solutions With Purpose
      </div>

      {/* Radial spotlight behind fg text */}
      <div className="solutions-spotlight" />

      {/* Foreground - fade-up on scroll */}
      <div
        ref={fgRef}
        className={`solutions-fg ${fgVisible ? "solutions-fg-visible" : ""}`}
      >
        <h2 className="solutions-heading">PRODUCT STUDIO PORTFOLIO</h2>
        <p className="solutions-desc">
          Beyond consulting, we design, build and ship our own products – proof that our Product Studio approach works end-to-end. Every product we build teaches us something new that makes the next client project better.
        </p>
      </div>
    </div>
  );
};

const UrimaiSlideshow = ({ screenshots, title }) => {
  return (
    <div className="urimai-carousel-container">
      <div className="carousel-center">
        {screenshots.map((screenshot, idx) => (
          <div key={idx} className={`carousel-card carousel-card-${idx + 1}`}>
            <img 
              src={screenshot} 
              alt={`${title} screenshot ${idx + 1}`}
              className="carousel-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const OurTools = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const navigate = useNavigate();

  // Device detection for Urimai
  const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return 'android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }
    return 'web';
  };

  // Click handler for Urimai app
  const handleUrimaiClick = () => {
    console.log('Urimai clicked');
    const device = detectDevice();
    let url;
    if (device === 'android') {
      url = 'https://play.google.com/store/apps/details?id=com.urimaiapp';
    } else if (device === 'ios') {
      url = 'https://apps.apple.com/in/app/urimai/id6475168659';
    } else {
      // Default to Android Play Store for web users
      url = 'https://play.google.com/store/apps/details?id=com.urimaiapp';
    }
    console.log('Opening URL:', url);
    window.open(url, '_blank');
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    const handleScroll = () => setShowScrollTop(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const scrollToProducts = () => {
    // Try to find the services container or urimai section as the first product
    const productsSection = document.querySelector('.services-container') || 
                           document.querySelector('.urimai-section');
    if (productsSection) {
      const offsetTop = productsSection.offsetTop - 100;
      window.scrollTo({ 
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  const handleWorkWithUs = () => {
    navigate('/contact');
  };

  return (
    <>
      <SEOHead 
        title="Our Products | AK Consultants"
        description="Explore AK Consultants' innovative software products including URIMAI - Civic Transparency Platform for informed voting and democratic transparency."
      />

      <div className="products-hero-wrapper">
        <FeaturedProductsHero onExploreProducts={scrollToProducts} onWorkWithUs={handleWorkWithUs} />
        <SolutionsInnovationStrip />
      </div>
      
      {/* <ProductPortfolioSection /> - Header moved inside services-container */}

      <div className="services-container" style={{ marginTop: '0px' }}>
        
        {/* COMMERCIALLY AVAILABLE Header */}
        <div className="portfolio-header-centered" data-aos="fade-up">
          <h2>COMMERCIALLY AVAILABLE</h2>
        </div>
        
        {/* URIMAI Section */}
        <div className="urimai-section" data-aos="fade-up">
          <div className="urimai-left">
            <div className="urimai-header">
              <div className="urimai-logo-wrapper">
                <img src={urimaiData.logo} alt="URIMAI Logo" className="urimai-logo" />
              </div>
              <div className="urimai-title-section">
                <h2 className="urimai-title" style={{ color: '#000000', fontWeight: 'bold', marginBottom: '8px' }}>{urimaiData.title}</h2>
                <p className="urimai-subtitle" style={{
                  fontSize: '18px',
                  color: '#666 !important',
                  margin: '0 0 8px 0',
                  fontWeight: '500',
                  lineHeight: '1.4',
                  pointerEvents: 'none'
                }}>{urimaiData.subtitle}</p>
              </div>
            </div>
            
            {/* Description comes after header, before features */}
            <p className="urimai-description" style={{
              fontSize: '16px',
              color: '#555',
              lineHeight: '1.6',
              margin: '0 0 16px 0',
              fontWeight: '400',
              textAlign: 'left'
            }}>
              <strong style={{ fontWeight: '700', color: '#333' }}>Tamil Nadu's first app,</strong> Turning thousands of election affidavits into one informed choice, Urimai empowers citizens with clear facts - because informed citizens build a stronger democracy.
              <br /><br />
              Urimai transforms how citizens engage with democracy by making political information accessible, searchable, and actionable. Our platform processes thousands of candidate affidavits to deliver clear insights about financial records, criminal cases, and electoral history.
            </p>
            
            {/* Features in 2 columns, 3 items each */}
            <div className="urimai-features-grid">
              <div className="features-column">
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Verified Candidate Profiles</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Smart Candidate Search</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Bilingual Accessibility (English & Tamil)</span>
                </div>
              </div>
              <div className="features-column">
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Financial & Criminal Record Analysis</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Real-Time Data Integration</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Transparent Public Information</span>
                </div>
              </div>
            </div>
            
            <div className="urimai-button-container">
              <button className="explore-btn-product" onClick={handleUrimaiClick}>
                <span>Try the Tool</span>
                <i className="fa fa-arrow-right" style={{ fontSize: '12px' }}></i>
              </button>
            </div>
          </div>

          <div className="urimai-right">
            <UrimaiSlideshow screenshots={urimaiData.screenshots} title={urimaiData.title} />
          </div>
        </div>

      </div>

      {/* NIDHI Section - Outside services-container for edge-to-edge design */}
      <div className="nidhi-section" data-aos="fade-up">
        <div className="nidhi-content">
          <div className="nidhi-left">
            <div className="devices-container">
              <div className="nidhi-devices-showcase">
                {/* Laptop Image - Larger, Main Background */}
                <img 
                  src={nidhiLaptopImg} 
                  alt="Nidhi Laptop Dashboard" 
                  className="nidhi-laptop-image"
                />
                
                {/* Mobile Image - Smaller, Overlay on Top Left */}
                <img 
                  src={nidhiMobileImg} 
                  alt="Nidhi Mobile App" 
                  className="nidhi-mobile-image"
                />
              </div>
            </div>
          </div>

          <div className="nidhi-right">
            <div className="nidhi-header">
              <div className="nidhi-logo-wrapper">
                <img src={nidhiLogo} alt="Nidhi Logo" className="nidhi-logo" />
              </div>
              <div className="nidhi-title-section">
                <h2 className="nidhi-title">Nidhi</h2>
                <p className="nidhi-subtitle">AI-Powered Invoice Processing & GST Compliance</p>
              </div>
            </div>
            
            <p className="nidhi-description">
              <strong>Enterprise-grade financial automation,</strong> Nidhi revolutionizes how businesses handle invoices and GST compliance. Our AI-powered platform processes thousands of invoices daily, ensuring accuracy and compliance while reducing manual effort by 90%.
              <br /><br />
              Built for Indian enterprises, Nidhi integrates seamlessly with existing ERP systems and provides real-time GST filing, automated invoice validation, and comprehensive financial analytics.
            </p>
            
            <div className="nidhi-features-grid">
              <div className="features-column">
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Automated GST Compliance</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Real-time Financial Analytics</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>AI Invoice Extraction & Validation</span>
                </div>
              </div>
              <div className="features-column">
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Multi-tenant Architecture</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>ERP System Integration</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Enterprise Security Standards</span>
                </div>
              </div>
            </div>
            
            <button className="btn-visit-nidhi" onClick={() => window.open('https://nidhi-ak.in/', '_blank')}>
              <span>Visit Nidhi</span>
              <i className="fa fa-arrow-right" style={{ fontSize: '12px' }}></i>
            </button>
          </div>
        </div>
      </div>

      {/* FACULTYOS Section - Content Left, Image Right */}
      <div className="facultyos-section" data-aos="fade-up">
        <div className="facultyos-content">
          <div className="facultyos-left">
            <div className="facultyos-header">
              <div className="facultyos-logo-wrapper">
                <img src={facultyOSLogo} alt="FacultyOS Logo" className="facultyos-logo" />
              </div>
              <div className="facultyos-title-section">
                <h2 className="facultyos-title">
                  <span style={{ fontWeight: '800' }}>Faculty</span>
                  <span style={{ fontWeight: '800', color: 'rgb(217, 182, 90)' }}>OS</span>
                </h2>
                <p className="facultyos-subtitle">Complete Faculty Workload Management System</p>
              </div>
            </div>
            
            <p className="facultyos-description">
              <strong>Academic excellence made simple,</strong> FacultyOS transforms how educational institutions manage faculty workloads and academic operations. Our comprehensive platform streamlines scheduling, workload distribution, and academic planning while ensuring compliance with institutional standards.
              <br /><br />
              Built for modern educational institutions, FacultyOS provides real-time insights into faculty allocation, course management, and institutional analytics, empowering administrators to make data-driven decisions.
            </p>
            
            <div className="facultyos-features-grid">
              <div className="features-column">
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Automated Workload Distribution</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Smart Scheduling System</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Real-time Analytics Dashboard</span>
                </div>
              </div>
              <div className="features-column">
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Course Management Integration</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Compliance Tracking</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Multi-campus Support</span>
                </div>
              </div>
            </div>
            
            <div className="facultyos-button-container">
              <button className="btn-visit-facultyos" onClick={() => window.open('https://www.facultyos.net/', '_blank')}>
                <span>Visit FacultyOS</span>
                <i className="fa fa-arrow-right" style={{ fontSize: '12px' }}></i>
              </button>
            </div>
          </div>

          <div className="facultyos-right">
            <img 
              src={facultyOSImg} 
              alt="FacultyOS Dashboard" 
              className="facultyos-image"
            />
          </div>
        </div>
      </div>

      {/* SCALING & DEPLOYMENT SOLUTIONS Section - Dark Blue Background */}
      <div className="scaling-deployment-section" data-aos="fade-up">
        <div className="scaling-deployment-container">
          <h2 className="scaling-deployment-title">Scaling & Deployment Solutions</h2>
          
          <div className="projects-grid">
            {/* ATRIP Project */}
            <TiltedCard
              imageSrc="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJyZ2JhKDIyMCwgMzgsIDM4LCAwLjA1KSIvPjwvc3ZnPg=="
              altText="ATRIP Project Background"
              containerHeight="100%"
              containerWidth="100%"
              imageHeight="100%"
              imageWidth="100%"
              scaleOnHover={1.05}
              rotateAmplitude={12}
              showMobileWarning={false}
              showTooltip={false}
              displayOverlayContent={true}
              overlayContent={
                <div className="project-card atrip-card full-size-card">
                  <div className="project-header">
                    <div className="project-icon atrip-icon">
                      <i className="fa fa-map-marker" style={{ fontSize: '32px', color: '#991b1b' }}></i>
                    </div>
                    <div className="project-info">
                      <h2 className="project-name">ATRIP</h2>
                      <p className="project-subtitle">(Active Travel Resilient Infrastructure Planner)</p>
                    </div>
                  </div>
                  
                  <h3 className="project-category">GEOSPATIAL & INFRASTRUCTURE PLANNING</h3>
                  <p className="project-description">
                    Platform helping planners design active travel infrastructure using policy, traffic and environmental data.
                  </p>
                  
                  <div className="features-grid-2x2">
                    <div className="feature-item-small">
                      <i className="fa fa-location-arrow"></i>
                      <span>Geospatial Intelligence</span>
                    </div>
                    <div className="feature-item-small">
                      <i className="fa fa-clipboard-list"></i>
                      <span>Policy & Standards Alignment</span>
                    </div>
                    <div className="feature-item-small">
                      <i className="fa fa-brain"></i>
                      <span>AI Decision Support</span>
                    </div>
                    <div className="feature-item-small">
                      <i className="fa fa-shield-alt"></i>
                      <span>Resilient Infrastructure Planning</span>
                    </div>
                  </div>
                </div>
              }
            />

            {/* IMPEL Project */}
            <TiltedCard
              imageSrc="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJyZ2JhKDEzOSwgOTIsIDI0NiwgMC4wNSkiLz48L3N2Zz4="
              altText="IMPEL Project Background"
              containerHeight="100%"
              containerWidth="100%"
              imageHeight="100%"
              imageWidth="100%"
              scaleOnHover={1.05}
              rotateAmplitude={12}
              showMobileWarning={false}
              showTooltip={false}
              displayOverlayContent={true}
              overlayContent={
                <div className="project-card impel-card full-size-card">
                  <div className="project-header">
                    <div className="project-icon impel-icon">
                      <i className="fa fa-users" style={{ fontSize: '32px', color: '#6d28d9' }}></i>
                    </div>
                    <div className="project-info">
                      <h2 className="project-name">IMPEL</h2>
                      <p className="project-subtitle">(Impact on People's Engagement Level)</p>
                    </div>
                  </div>
                  
                  <h3 className="project-category">CITIZEN ENGAGEMENT & CONSULTATION</h3>
                  <p className="project-description">
                    Platform improving public consultation through sentiment analysis, visualisation and feedback management.
                  </p>
                  
                  <div className="features-grid-2x2">
                    <div className="feature-item-small">
                      <i className="fa fa-cogs"></i>
                      <span>Public Engagement</span>
                    </div>
                    <div className="feature-item-small">
                      <i className="fa fa-smile"></i>
                      <span>Sentiment Analytics</span>
                    </div>
                    <div className="feature-item-small">
                      <i className="fa fa-cube"></i>
                      <span>3D / AR Visualisation</span>
                    </div>
                    <div className="feature-item-small">
                      <i className="fa fa-sync-alt"></i>
                      <span>Feedback Loop Management</span>
                    </div>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </div>

      {/* EMERGING INNOVATIONS Section */}
      <div className="emerging-innovations-section-white" data-aos="fade-up">
        <div className="emerging-innovations-container-white">
          <h2 className="emerging-innovations-title-orange">EMERGING INNOVATIONS</h2>
          
          <div className="emerging-innovations-grid-single-row">
            {/* Course Curator */}
            <TiltedCard
              imageSrc="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJyZ2JhKDI0OSwgMTE1LCAyMiwgMC4wNSkiLz48L3N2Zz4="
              altText="Course Curator Background"
              containerHeight="100%"
              containerWidth="100%"
              imageHeight="100%"
              imageWidth="100%"
              scaleOnHover={1.05}
              rotateAmplitude={12}
              showMobileWarning={false}
              showTooltip={false}
              displayOverlayContent={true}
              overlayContent={
                <div className="emerging-innovation-card-compact">
                  <div className="emerging-innovation-card-content">
                    <div className="emerging-innovation-icon" style={{ background: 'white', borderRadius: '10px', padding: '10px' }}>
                      <img src={courseCuratorLogo} alt="Course Curator" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />
                    </div>
                    <div className="emerging-innovation-info">
                      <h2 className="emerging-innovation-name">COURSE CURATOR</h2>
                      <p className="emerging-innovation-subtitle">AI-powered platform for designing outcome-based courses.</p>
                    </div>
                  </div>
                </div>
              }
            />

            {/* THISAI */}
            <TiltedCard
              imageSrc="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJyZ2JhKDU5LCAxMzAsIDI0NiwgMC4wNSkiLz48L3N2Zz4="
              altText="THISAI Background"
              containerHeight="100%"
              containerWidth="100%"
              imageHeight="100%"
              imageWidth="100%"
              scaleOnHover={1.05}
              rotateAmplitude={12}
              showMobileWarning={false}
              showTooltip={false}
              displayOverlayContent={true}
              overlayContent={
                <div className="emerging-innovation-card-compact">
                  <div className="emerging-innovation-card-content">
                    <div className="emerging-innovation-icon" style={{ background: 'white', borderRadius: '10px', padding: '10px' }}>
                      <img src={thisaiLogo} alt="THISAI" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />
                    </div>
                    <div className="emerging-innovation-info">
                      <h2 className="emerging-innovation-name">THISAI</h2>
                      <p className="emerging-innovation-subtitle">Helps students choose courses based on personality, strengths and interests.</p>
                    </div>
                  </div>
                </div>
              }
            />

            {/* Fetal Monitoring Belt */}
            <TiltedCard
              imageSrc="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJyZ2JhKDIyMCwgMzgsIDM4LCAwLjA1KSIvPjwvc3ZnPg=="
              altText="Fetal Monitoring Belt Background"
              containerHeight="100%"
              containerWidth="100%"
              imageHeight="100%"
              imageWidth="100%"
              scaleOnHover={1.05}
              rotateAmplitude={12}
              showMobileWarning={false}
              showTooltip={false}
              displayOverlayContent={true}
              overlayContent={
                <div className="emerging-innovation-card-compact">
                  <div className="emerging-innovation-card-content">
                    <div className="emerging-innovation-icon" style={{ background: '#dc2626', borderRadius: '10px', padding: '14px' }}>
                      <i className="fa fa-heartbeat" style={{ fontSize: '36px', color: 'white' }}></i>
                    </div>
                    <div className="emerging-innovation-info">
                      <h2 className="emerging-innovation-name">FETAL MONITORING BELT</h2>
                      <p className="emerging-innovation-subtitle">Continuous non-invasive fetal movement monitoring.</p>
                    </div>
                  </div>
                </div>
              }
            />

            {/* FalconLink */}
            <TiltedCard
              imageSrc="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJyZ2JhKDI0OSwgMTE1LCAyMiwgMC4wNSkiLz48L3N2Zz4="
              altText="FalconLink Background"
              containerHeight="100%"
              containerWidth="100%"
              imageHeight="100%"
              imageWidth="100%"
              scaleOnHover={1.05}
              rotateAmplitude={12}
              showMobileWarning={false}
              showTooltip={false}
              displayOverlayContent={true}
              overlayContent={
                <div className="emerging-innovation-card-compact">
                  <div className="emerging-innovation-card-content">
                    <div className="emerging-innovation-icon" style={{ background: '#f97316', borderRadius: '10px', padding: '14px' }}>
                      <i className="fa fa-broadcast-tower" style={{ fontSize: '36px', color: 'white' }}></i>
                    </div>
                    <div className="emerging-innovation-info">
                      <h2 className="emerging-innovation-name">FALCONLINK</h2>
                      <p className="emerging-innovation-subtitle">Advanced RF connectivity for long-range, low-power communications.</p>
                    </div>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </div>

      {showScrollTop && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          <i className="fa fa-arrow-up" style={{ position: 'relative', right: '1.5px' }}></i>
        </button>
      )}

      <Footer />
    </>
  );
};

export default OurTools;

